module.exports = __webpack_public_path__ + "static/media/27.db85e1c1.jpg";